import { apiClient } from './client';
import { unwrapList, unwrapItem } from './unwrap';
import type { Category, PagedResult } from './types';

export const categoriesApi = {
  listForCompetition: (competitionId: string) =>
    apiClient
      .get('/categories', { params: { competitionId } })
      .then((r) => unwrapList<Category>(r.data)) as Promise<PagedResult<Category>>,

  get: (id: string) => apiClient.get(`/categories/${id}`).then((r) => unwrapItem<Category>(r.data)),

  create: (payload: Partial<Category>) =>
    apiClient.post<Category>('/categories', payload).then((r) => r.data),

  update: (id: string, payload: Partial<Category>) =>
    apiClient.put<Category>(`/categories/${id}`, payload).then((r) => r.data),

  remove: (id: string) => apiClient.delete(`/categories/${id}`).then((r) => r.data),
};
